import React, { Component } from 'react'
import { useSelector, useDispatch, connect } from 'react-redux'
import Carousel from 'react-bootstrap/Carousel';

import {
    CInputGroupText,
    CInputGroupAppend,
    CBadge,
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CDataTable,
    CRow,
    CFormGroup,
    CInputGroup,
    CInput,
    CButton,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownItem,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CTooltip,
    CPopover,
    CLabel,
    CSelect,
    CFormText,
    CTextarea,
    CInputFile,
    CSwitch,
} from '@coreui/react'
import { createHashHistory } from 'history'
import HeaderSection from "../header/HeaderSection"
import FooterSection from '../Footer/FooterSection'
import { Link } from 'react-router-dom'
import Adminsidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
const history = createHashHistory()
const Basictables = (props) => {
        return (
            <div>
        {/* Mirrored from dreamguys.co.in/demo/doccure/admin/tables-basic.html by HTTrack Website Copier/3.x [XR&CO'2014], Sat, 30 Nov 2019 04:12:56 GMT */}
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />
        <title>Doccure - Tables Basic</title>
        {/* Favicon */}
        <link rel="shortcut icon" type="image/x-icon" href="assets/img/favicon.png" />
        {/* Bootstrap CSS */}
        <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
        {/* Fontawesome CSS */}
        <link rel="stylesheet" href="assets/css/font-awesome.min.css" />
        {/* Feathericon CSS */}
        <link rel="stylesheet" href="assets/css/feathericon.min.css" />
        {/* Main CSS */}
        <link rel="stylesheet" href="assets/css/style.css" />
        {/*[if lt IE 9]>
			
			
		<![endif]*/}
        
          
          {/* Page Wrapper */}
          <div className="page-wrapper p-1">
            <div className="content container-fluid ">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Basic Tables</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item"><Link to="/admin">Dashboard</Link></li>
                      <li className="breadcrumb-item active">Basic Tables</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Basic Table</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table mb-0">
                          <thead>
                            <tr>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>John</td>
                              <td>Doe</td>
                              <td>john@example.com</td>
                            </tr>
                            <tr>
                              <td>Mary</td>
                              <td>Moe</td>
                              <td>mary@example.com</td>
                            </tr>
                            <tr>
                              <td>July</td>
                              <td>Dooley</td>
                              <td>july@example.com</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Striped Rows</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-striped mb-0">
                          <thead>
                            <tr>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>John</td>
                              <td>Doe</td>
                              <td>john@example.com</td>
                            </tr>
                            <tr>
                              <td>Mary</td>
                              <td>Moe</td>
                              <td>mary@example.com</td>
                            </tr>
                            <tr>
                              <td>July</td>
                              <td>Dooley</td>
                              <td>july@example.com</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Bordered Table</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>John</td>
                              <td>Doe</td>
                              <td>john@example.com</td>
                            </tr>
                            <tr>
                              <td>Mary</td>
                              <td>Moe</td>
                              <td>mary@example.com</td>
                            </tr>
                            <tr>
                              <td>July</td>
                              <td>Dooley</td>
                              <td>july@example.com</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Hover Rows</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead>
                            <tr>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>John</td>
                              <td>Doe</td>
                              <td>john@example.com</td>
                            </tr>
                            <tr>
                              <td>Mary</td>
                              <td>Moe</td>
                              <td>mary@example.com</td>
                            </tr>
                            <tr>
                              <td>July</td>
                              <td>Dooley</td>
                              <td>july@example.com</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Contextual Classes</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table mb-0">
                          <thead>
                            <tr>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Default</td>
                              <td>Defaultson</td>
                              <td>def@somemail.com</td>
                            </tr>
                            <tr className="table-primary">
                              <td>Primary</td>
                              <td>Doe</td>
                              <td>john@example.com</td>
                            </tr>
                            <tr className="table-secondary">
                              <td>Secondary</td>
                              <td>Moe</td>
                              <td>mary@example.com</td>
                            </tr>
                            <tr className="table-success">
                              <td>Success</td>
                              <td>Dooley</td>
                              <td>july@example.com</td>
                            </tr>
                            <tr className="table-danger">
                              <td>Danger</td>
                              <td>Refs</td>
                              <td>bo@example.com</td>
                            </tr>
                            <tr className="table-warning">
                              <td>Warning</td>
                              <td>Activeson</td>
                              <td>act@example.com</td>
                            </tr>
                            <tr className="table-info">
                              <td>Info</td>
                              <td>Activeson</td>
                              <td>act@example.com</td>
                            </tr>
                            <tr className="table-light">
                              <td>Light</td>
                              <td>Activeson</td>
                              <td>act@example.com</td>
                            </tr>
                            <tr className="table-dark">
                              <td>Dark</td>
                              <td>Activeson</td>
                              <td>act@example.com</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Responsive Tables</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Age</th>
                              <th>City</th>
                              <th>Country</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>			
          </div>
          {/* /Main Wrapper */}
        </div>
         );
  }
// export default TheHeaderDropdown
const mapStateToProps = (state) => ({
})
export default connect(mapStateToProps, {
})(Basictables)